import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { _IncomeDocument, _single } from "../../core/services/dataBean/EntityCatalog";
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { BasicButton } from "../theme/Component/BasicButton";
import { BasicPage } from "../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import useDataBean from "../../core/services/dataBean/useDataBean";
import usePaginator from "../theme/Component/usePaginator";
import AutoChart, { HeadColumn } from "../../core/graph/AutoChart";
import { DropDown } from "../theme/Component/DropDown";
import { Modal } from "../theme/Component/Modal";
import useModal, { MODAL_SM, MODAL_XL } from "../theme/Component/hooks/useModal";
import { ExportXLSL } from "../theme/Component/ExportXLSX";
import { SelectMonths } from "../contract/select/SelectMonths";
import { SelectAccountantConcept } from "../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConcept";
import { SelectAccountantConceptForIncomeDocument } from "./IncomeDocument/Components/SelectAccountantConceptForIncomeDocument";


export const IncomeCompensationDocumentReport = () => {

    const _income = useDataBean(_IncomeDocument);
    const [year, setYear] = useState<number | null>(_single.getCurrenYear());
    const [month, setMonth] = useState<number | null>(_single.getCurrentMonth());
    const [idAccountantConcept, setIDAccountantConcept] = useState<number | null>(null);
    const [rows, setRows] = useState<any[]>([]);     
    const [rowsAll, setRowsAll] = useState<any[]>([]);     
    const [bean,setBean] = useState<any>({});   
    const paginator = usePaginator();
    const modalGraph = useModal("Reporte gráfico", MODAL_XL);
    const modalExcel = useModal("Descargar Excel",MODAL_SM);

    const head: HeadColumn[] = [
        {title:"Concepto",property:"AccountantConceptName",visible:true},
        {title:"Nemonico",property:"Mnemonic",visible:true},
        {title:"Consecutivo",property:"Consecutive",visible:true,mask:MASK_NUMBER},
        {title:"Fecha Compensación",property:"DocumentDate",visible:true,mask:MASK_DATE},
        {title:"Valor",property:"Value",visible:true,mask:MASK_MONEY},
        // {title:"Nemonico Ingreso",property:"IADMnemonic",visible:true},
        {title:"Consecutivo IAD",property:"IADConsecutive",visible:true,mask:MASK_NUMBER},
        {title:"Fecha IAD",property:"IADDocumentDate",visible:true,mask:MASK_DATE},
    ]

    const actionsDropDown = [
        { id: 1, name: "Reporte Gráfico", permiso: null, activo: true },
        { id: 2, name: "Descargar Excel", permiso: null, activo: true },
    ];

    useEffect(()=>{
        search();
    },[paginator.page])

    const buttons = () => (
        <div className="row">
            <div className="col-md-12">
                <DropDown
                    lista={actionsDropDown}
                    eventClick={(action) => {
                        if (action.id === 1) {getAll(); modalGraph.open();};
                        if (action.id === 2) {getAll(); modalExcel.open();};
                    }}
                />
            </div>
        </div>
    );

    const search = () => {
        if (!year) {
            toast.warning("Debe seleccionar el año.");
            return;
        }

       
        let props = {
            Month:month,
            Year:year,
            IDAccountantConcept:idAccountantConcept,
        }

        _income.instance.getIncomeCompensationDocumentReport(paginator.page,15,_single.cleanMap(props)).then(
            (resp:any)=>
            {
                setRows(resp.List);
                paginator.setPages(resp.NumberOfPages);
            
        });
    };
    const getAll =()=>{
         if (!year) {
            toast.warning("Debe seleccionar el año.");
            return;
        }

        
        let props = {
            Month:month,
            Year:year,
            IDAccountantConcept:idAccountantConcept,
        }

        _income.instance.getIncomeCompensationDocumentReport(1,paginator.pages*15,_single.cleanMap(props)).then(
            (resp:any)=>
            {
                setRowsAll(resp.List);
            
        });
    }

    return (
        <BasicPage titulo="Reporte Compensación de Ingresos">
            <div className="row align-items-end">
                <div className="col-md-3">
                    <YearSelector
                        tittle="Año *"
                        value={year}
                        onChange={(value) => setYear(value)}
                    />
                </div>
                <div className="col-md-3">
                    <SelectMonths idSelector={month} onChange={(e)=>setMonth(e)} label="Mes*"/>
                </div>
                <div className="col-md-3">
                    <SelectAccountantConceptForIncomeDocument
                     idSelector={idAccountantConcept} 
                     onChange={(e) => { setIDAccountantConcept(parseInt(e)) }} 
                     />
                    {/* <SelectAccountantConcept idSelector={idAccountantConcept} onChange={(e)=>setIDAccountantConcept(e)} label="Concepto Ingreso"/> */}
                </div>
                <div className="col-md-3">
                    <BasicButton
                        icon="ri-file-search-line"
                        eventClick={search}                                                
                    >
                        Consultar
                    </BasicButton>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <BasicTable
                        body={rows}
                        head={head}
                        headButtons={buttons()}
                        rowSet={setBean}                        
                        records={paginator}
                        
                    />
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart
                            data={rowsAll}
                            head={head}
                            useIndexAsXLabel={true}
                            xOptions={["AccountantConceptName", "Mnemonic", "DocumentDate"]}
                            yOptions={["Value"]}
                            exportFileName="reporte_documentos_compensacion_ingresos"
                        />
                    </Modal>
                    <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal}>
                        {rows.length > 0 && (
                            <ExportXLSL
                                customName="reporte_documentos_compensacion_ingresos"
                                optionIcon="ri-download-cloud-2-line text-success"
                                title={head}
                                data={rowsAll}
                                onExport={(name: string) => {
                                    _single.download(`formato xlsx [${name}] con ${rows.length} registros`);
                                }}
                            />
                        )}
                    </Modal>
                </div>
            </div>
        </BasicPage>
    );
};

export default IncomeCompensationDocumentReport;
